import { ProductCardVariant } from '~/components/ProductCardV3';
import ProductCardSkeletonFactory from '~/components/ProductCardV3/skeletons/ProductCardSkeletonFactory';

import styles from './RecommendationSliderSkeleton.module.scss';

interface RecommendationSliderSkeletonProps {
  count?: number;
  size?: Extract<ProductCardVariant, 'm' | 's'>;
}

const RecommendationSliderSkeleton = ({
  count = 6,
  size = 's',
}: RecommendationSliderSkeletonProps) => {
  return (
    <div className={styles.skeletonContainer}>
      {Array.from({ length: count }, (_, i) => (
        <ProductCardSkeletonFactory key={`skeleton-${i}`} variant={size} />
      ))}
    </div>
  );
};

export default RecommendationSliderSkeleton;
